// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const TestingInstructionApplyModeSchema = z.enum(['ALWAYS','AUTO_ATTACHED','AGENT_REQUESTED','MANUAL'] as const);

export type TestingInstructionApplyModeType = `${z.infer<typeof TestingInstructionApplyModeSchema>}`

export default TestingInstructionApplyModeSchema;
